export const dateutil = {
  diffInDays: (date1: Date | undefined, date2: Date | undefined): number | undefined => {
    if (!date1 || !date2) return undefined;
    const diffTime = Math.abs(date2.getTime() - date1.getTime());
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  },
  addDays: (d: Date, days: number): Date => {
    const nd = new Date(d.valueOf());
    nd.setDate(nd.getDate() + days);
    return nd;
  },
  addHours: (date: Date, hours: number) => {
    const hoursToAdd = hours * 60 * 60 * 1000;
    const nd = new Date(date.valueOf());
    nd.setTime(date.getTime() + hoursToAdd);
    return nd;
  },
  cutToDateOnly: (date: Date): Date => {
    // 시, 분, 초, 밀리초를 0으로 설정하여 년월일만 남깁니다.
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  },
  toYYMMDD: (date: Date): string => {
    const yy = date.getFullYear().toString().slice(-2);
    const mm = ('' + (date.getMonth() + 1)).padStart(2, '0');
    const dd = ('' + date.getDate()).padStart(2, '0');
    return `${yy}${mm}${dd}`;
  },
  toYMDDash: (date: Date): string => {
    const yy = date.getFullYear().toString().slice(-2);
    const mm = ('' + (date.getMonth() + 1)).padStart(2, '0');
    const dd = ('' + date.getDate()).padStart(2, '0');
    return `${yy}-${mm}-${dd}`;
  },
  toYyyyMDDash: (date: Date): string => {
    const yy = date.getFullYear().toString();
    const mm = ('' + (date.getMonth() + 1)).padStart(2, '0');
    const dd = ('' + date.getDate()).padStart(2, '0');
    return `${yy}-${mm}-${dd}`;
  },
};
